import { useEffect, memo, Suspense, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'

import Header from '@components/Header'
import Content from '@components/Hocs/Content'
import { RouteEnum } from '@appTypes/enums/global'

import { savePrevPathname } from '@store/features/general/general.slice'
import usePrevious from '@hook/usePrevious'
import { useAppDispatch, useAppSelector } from '@store/hooks'
import { scrollToTop } from '@utils/scroll'
import { ContentHeader } from './components'
import { ContentLoader } from './styled'
import MobileHeader from './components/MobileMenu'

function LayoutPrivate() {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const [isOpen, setIsOpen] = useState<boolean>(false)

  const { disableBackButton, prevPages } = useAppSelector((state) => state.general)
  const prevPathArray = usePrevious<string[]>(prevPages)
  const prevPath = usePrevious<string>(location.pathname)

  useEffect(() => {
    scrollToTop()

    if (prevPath && prevPages.length === prevPathArray.length) {
      dispatch(savePrevPathname({ pathname: prevPath }))
    }
  }, [location.pathname])

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden'
    } else {
      document.body.style.overflow = 'unset'
    }
  }, [isOpen])

  return (
    <>
      <Header setIsOpen={setIsOpen} type={RouteEnum.PRIVATE} />
      <Content type={RouteEnum.PRIVATE}>
        <MobileHeader isOpen={isOpen} setIsOpen={setIsOpen} />
        <Suspense fallback={<ContentLoader />}>
          {!disableBackButton ? <ContentHeader /> : null}
          <Outlet />
        </Suspense>
      </Content>
    </>
  )
}

export default memo(LayoutPrivate)
